import React from 'react';
import { FormattedMessage } from 'react-intl';
import NamedLinkNewTab from '../../../../../components/NamedLink/NamedLinkNewTab';
import IconReviewSearchPage from '../../../../ListingPage/ListingPageComponents/ReviewRatings/IconReviewSearchPage/iconReviewSearchPage';
import styles from '../Experience.module.css';

const ExperienceCard = ({ item, shortName, currentLanguage }) => {
  if (!item) return null;

  const listingId = item.link?.substring(item.link?.lastIndexOf('/') + 1);
  //const projectTypes = Array.isArray(item.projectType) ? item.projectType : [];

  return (
    <NamedLinkNewTab name={item.linkName} params={item.linkParams}>
      <div
        className={styles.oneCard}
        data-elbaction={
          item?.isExperience
            ? `click:click lp-impct-exp-${shortName}-uuid-${listingId}`
            : `click:click lp-impct-list-${shortName}-uuid-${listingId}`
        }
      >
        <img className={styles.img} src={item.image} alt="socialbnb impact accommodation" />

        <div className={styles.spanDescription}>
          <div className={styles.listDescriptionWrapper}>
            <div className={styles.descriptionTxt}>
              <span className={styles.name}>{shortName}</span>
              <span className={styles.location}>
                {currentLanguage === 'de' ? item.location_de : item.location}
              </span>
              <div className={styles.secondaryInformation}>
                <span className={styles.priceSubtitle}>
                  {item?.isExperience ? (
                    <>{currentLanguage === 'de' ? item?.stayPriceRangeDe : item?.stayPriceRange}</>
                  ) : (
                    <>
                      <span className={styles.price}>{item.price}</span>
                      <FormattedMessage id="landing.accomodations.pernight" />
                    </>
                  )}
                </span>
                {item.finalReviews > 0 ? (
                  <div className={styles.projectRatings}>
                    <IconReviewSearchPage
                      averageRating={item.finalReviews}
                      showDot={false}
                      textColor="black"
                      showReviewsNumber={true}
                      reviewsNumber={item.finalReviewsCount}
                      decimals={1}
                    />
                  </div>
                ) : (
                  <div className={styles.emptySpacer} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </NamedLinkNewTab>
  );
};

export default ExperienceCard;
